import { render } from "./UsdValue.vue?vue&type=template&id=8fccca60&scoped=true"
import script from "./UsdValue.vue?vue&type=script&lang=js"
export * from "./UsdValue.vue?vue&type=script&lang=js"

import "./UsdValue.vue?vue&type=style&index=0&id=8fccca60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fccca60"]])

export default __exports__